<template>
  <b-navbar
    class="article"
  >
    <div class="container">
      <a
        href="#"
        class="object-nav-prev"
        :aria-label="$t('common:share.back')"
        :class="{
          disabled: objectNavActive === 0
        }"
        data-ident="objectNavPrev"
        @click.prevent="objectNavPrev"
      >
        <i class="icon"><icon-chevron-left-alternative /></i>
      </a>
      <a
        href="#"
        class="object-nav-next"
        :aria-label="$t('common:share.forward')"
        :class="{
          disabled: objectNavActive === navigationItems.length - 1
        }"
        data-ident="objectNavNext"
        @click.prevent="objectNavNext"
      >
        <i class="icon"><icon-chevron-right-alternative /></i>
      </a>
      <b-navbar-nav>
        <li class="nav-item" />
        <li
          v-for="(navigationItem) in navigationItems"
          :key="navigationItem.id"
          ref="navbarRefs"
          class="nav-item"
          :class="{active: navigationItem.id === sspyMixin_currentSection}"
          :data-sort="navigationItem.sort"
        >
          <a
            v-smooth-scroll="{
              duration: 200,
              updateHistory: false,
            }"
            target="_self"
            :href="navigationItem.container"
            class="nav-link"
          >
            <span>
              {{ navigationItem.label }}
            </span>
          </a>
        </li>
        <li class="nav-item" />
      </b-navbar-nav>

      <div class="object-id d-none d-lg-inline-block">
        {{ $t('common:accommodationNumber') }}<em> {{ objectNumber }}</em>
      </div>
    </div>
  </b-navbar>
</template>

<script>
import {
  BNavbar,
  BNavbarNav,
} from 'bootstrap-vue';
import ScrollSpy from 'mixins/ScrollSpy';

/* ICONS */
import IconChevronLeftAlternative from 'ICON:IconChevronLeftAlternative';
import IconChevronRightAlternative from 'ICON:IconChevronRightAlternative';

export default {
  name: 'ObjectNavbar',
  i18nOptions: { namespaces: 'common' },
  components: {
    IconChevronLeftAlternative,
    IconChevronRightAlternative,
    BNavbar,
    BNavbarNav,
  },
  mixins: [
    ScrollSpy,
  ],
  props: {
    availableSections: {
      type: Object,
      required: true,
    },
    sectionsRefs: {
      type: Object,
      required: true,
    },
    objectNumber: {
      required: true,
      type: [Number, String],
      validator(value) {
        return value === 0 || parseInt(value, 10);
      },
    },

  },
  data() {
    return {
      objectNavActive: 0,
    };
  },
  computed: {
    navigationItems() {
      // sort by .sort property and reduce by .available property
      const navigationSorted = Object.values(this.availableSections)
        .sort((a, b) => a.sort - b.sort);
      return navigationSorted;
    },
  },
  watch: {
    sspyMixin_currentSection(newValue) {
      Object.values(this.navigationItems).forEach((navigationItem) => {
        if (navigationItem.id === newValue) {
          // scrollBehaviour smooth and scrollIntoViewOptions poorly supported by browsers
          if (this.$refs.navbarRefs[navigationItem.sort]?.nextSibling) {
            this.$refs.navbarRefs[navigationItem.sort].nextSibling.scrollIntoView(true);
          }
          if (this.$refs.navbarRefs[navigationItem.sort]?.previousSibling) {
            this.$refs.navbarRefs[navigationItem.sort].previousSibling.scrollIntoView(true);
          }
          this.objectNavActive = parseInt(navigationItem.sort, 10);
        }
      });
    },
  },
  mounted() {
    this.sspymixin_scrollSpy(this.availableSections, this.sectionsRefs, 35, 15);
  },
  methods: {
    objectNavPrev() {
      if (this.objectNavActive <= 0) {
        this.objectNavActive = 0;
      } else {
        this.objectNavActive -= 1;
      }
      this.$refs.navbarRefs[this.objectNavActive].firstChild.click();
    },
    objectNavNext() {
      if (this.objectNavActive >= this.navigationItems.length - 1) {
        this.objectNavActive = this.navigationItems.length - 1;
      } else {
        this.objectNavActive += 1;
      }
      this.$refs.navbarRefs[this.objectNavActive].firstChild.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.object-nav-prev,
.object-nav-next {
  @include transition_fast;

  position: fixed;
  z-index: 2000;
  top: -50px;
  display: none;
  margin: 0;
  padding: 0;
  color: var(--color_text);
  pointer-events: none;

  @media #{$media_sm_max} {
    display: block;
  }

  &.disabled {
    opacity: 0.1;
  }

  .headerMain_invisible & {
    pointer-events: auto;
    top: 0;
  }
}

.object-nav-prev {
  left: 0;
  height: 2.5em;
  overflow: hidden;

  &::after {
    content: ' ';
    height: 2.5em;
    display: inline-block;

    @include gradient_ltr(#fff, rgba(#fff, 0));

    width: 0.5em;
  }

  i {
    background: #fff;
    padding: 0 0.25em;
    float: left;
    height: 2.5em;
    line-height: 2.5em;
  }
}

.object-nav-next {
  right: 0;
  height: 2.5em;
  overflow: hidden;

  &::before {
    content: ' ';
    height: 2.5em;
    display: inline-block;

    @include gradient_ltr(rgba(#fff, 0), #fff);

    width: 0.5em;
  }

  i {
    background: #fff;
    padding: 0 0.25em;
    float: right;
    height: 2.5em;
    line-height: 2.5em;

  }
}

nav.navbar.article {
  position: fixed;
  z-index: 2000;
  top: -50px;
  margin: 0;
  padding: 0;
  width: 100%;
  background: #fff;

  @include transition_fast;

  pointer-events: none;
  border-bottom: 1px solid $color_grey_100;
  overflow-x: auto;
  max-width: 2000px;

  .headerMain_invisible & {
    pointer-events: auto;
    top: 0;
  }

  a.nav-link {
    transition: color 0.1s linear;
    color: var(--color_text);
    padding: 0 0.75em;
    span {
      height: 2.5em;
      line-height: 2.5em;
      display: block;
    }

    @include font_bold;

    text-decoration: none;
    border: none;

    #app:not(.isTouchDevice) &:hover {
      color: var(--color_ci);
    }
  }

  .nav-item {
    &.active {
      .nav-link {
        color: var(--color_ci);
        span {
          border-bottom: 3px solid var(--color_ci);
        }
      }
    }
    &:first-child {
      margin-left: -0.75em;

      @media #{$media_xs} {
        padding-left: 2em;
      }
    }
    &:last-child {
      padding-right: 2em;
    }
  }
}

.object-id {
  em {
    @include font_bold;
  }
}
</style>
